<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Tripulação</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label> Equipe </label>
                        <v-select
                          :options="equipes"
                          :reduce="(equipes) => equipes.id"
                          :label="'equipe_nome'"
                          v-model="entity.equipe_id"
                          class="vselect"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name"> Tripulante: </label>
                        <select
                          class="form-control"
                          v-model="entity.tripulante_id"
                        >
                          <option
                            v-for="tripulante in tripulantes"
                            :key="tripulante.tripulante_id"
                            :value="tripulante.tripulante_id"
                          >
                            {{ tripulante.tripulante_nome }}
                          </option>
                        </select>
                      </div>
                      <!-- <div class="form-group col-md-6">
                        <label> Usuário </label>
                        <v-select
                          :options="usuarios"
                          :reduce="(usuarios) => usuarios.id"
                          :label="'usuario_nome'"
                          v-model="entity.usuario_id"
                          class="vselect"
                        />
                      </div> -->

                      <div class="form-group col-md-6">
                        <label for="Name"> Status: </label>
                        <select v-model="entity.status" class="form-control">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/tripulacaos" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      entity: {
        equipe_id: "",
        tripulante_id: "",
        status: "1",
      },
      equipes: [],
      usuarios: [],
      tripulantes: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "tripulacaos";

      if (self.entity.tripulacao_id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.tripulacao_id;
      }

      axios
        .post(api, self.entity)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/tripulacaos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "tripulacaos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEquipe: function () {
      const self = this;
      let api = self.$store.state.api + "equipes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.equipes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTripulante: function () {
      const self = this;
      let api = self.$store.state.api + "tripulantes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tripulantes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsuario: function () {
      const self = this;
      let api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.usuarios = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getEquipe();
    self.getUsuario();
    self.getTripulante();

    let id = self.$route.params.id;
    if (id) {
      self.getEntity(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>